import { isAdminRole } from './isAdminRole';

// Utils ==============================

// Team trial status

export const isTrialingTeamAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => account?.isTrialingTeams));

export const wasTrialingTeamAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => !!account?.teamTrialEndDate));

export const isOrWasTrialingTeamAccount = (accounts: any[] = []) =>
  isTrialingTeamAccount(accounts) || wasTrialingTeamAccount(accounts);

// Team account status

export const isTeamAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => account?.plan?.type === 'Team'));

export const wasTeamAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => !!account?.teamAccountEndDate));

export const isOrWasTeamAccount = (accounts: any[] = []) =>
  isTeamAccount(accounts) || wasTeamAccount(accounts);

// Company trial status

export const isTrialingCompanyAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => account?.isTrialingCompanies));

export const wasTrialingCompanyAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => account?.hasBeenInCompaniesTrial));

export const isOrWasTrialingCompanyAccount = (accounts: any[] = []) =>
  isTrialingCompanyAccount(accounts) || wasTrialingCompanyAccount(accounts);

// Company account status

export const isCompanyAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => account?.plan?.allowCompanies));

export const wasCompanyAccount = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => !!account?.companyAccountEndDate));

export const isOrWasCompanyAccount = (accounts: any[] = []) =>
  isCompanyAccount(accounts) || wasCompanyAccount(accounts);

// Miscellaneous

export const hasMemberRole = (accounts: any[] = []) =>
  Boolean(
    accounts.some((account: any) => !isAdminRole(account?.currentUserRole))
  );

export const hasTeamFeatures = (accounts: any[] = []) =>
  Boolean(accounts.some((account: any) => account?.plan?.hasTeams));

// Eligibility ========================

export const isEligibleForTeamTrial = (accounts?: any[]) =>
  !isOrWasTrialingTeamAccount(accounts) &&
  !isOrWasTrialingCompanyAccount(accounts) &&
  !isOrWasTeamAccount(accounts) &&
  !isOrWasCompanyAccount(accounts) &&
  !hasMemberRole(accounts);

export const isEligibleForTeamPurchase = (accounts?: any[]) =>
  !isTeamAccount(accounts) && !hasMemberRole(accounts);

export const isEligibleForCompanyTrial = (accounts?: any[]) =>
  !isOrWasTrialingCompanyAccount(accounts) &&
  !isOrWasCompanyAccount(accounts) &&
  !hasMemberRole(accounts);

export const isEligibleForCompanyPurchase = (accounts?: any[]) =>
  !isCompanyAccount(accounts) && !hasMemberRole(accounts);
